module.exports = __webpack_public_path__ + "static/media/Redirect.b39c4118.svg";